import createBaseRendererServerMessages from "./createBaseRendererServerMessages";

export default createBaseRendererServerMessages({
  name: "doplnkovaSluzbaFull",
  kodKey: "nazev",
  placeholderText: "Použití elektrické lokomotivy Vectron včetně obsluhy"
});
